<template>
  <div class="layout">
    <img class="banner" :src="banner" alt />
    <div class="logos">
      <div class="logo" v-for="item in categoryList" :key="item.categoryId">
        <img
          :src="$store.state.baseUrl + '/images/' + item.categorySmallimg"
          :title="item.categoryTitle"
          @click="chooseCategory(item.categoryId)"
        />
      </div>
    </div>
    <div class="intro" v-html="html"></div>
    <foot></foot>
  </div>
</template>

<script>
import foot from "@/components/Foot";
import { oauthToken } from "@/api/user";
import { mapActions } from "vuex";
export default {
  components: {
    foot,
  },
  data() {
    return {
      categoryList: [],
      html: '',
      banner: '',
      article: ''
    };
  },
  created() {
    oauthToken().then((res) => {
      localStorage.setItem("access_token", res.data.access_token);
    });
    this.findAll({ categoryType: "1" }).then((res) => {
      this.categoryList = res.data;
      this.$store.commit("setCategoryList", res.data);
    });
    this.findPage({
      basicCategoryid: 349,
    }).then((res) => {
      let id = res.data.dataList[0].basicId;
      this.getArticle(id).then(res => {
        this.article = res.data;
        let html = res.data.articleContent.replace(
          /href="\.\.\/images/g,
          'target="_blank" href="' + this.$store.state.baseUrl + 'images'
        );
        html = html.replace(
          /src="http/g,
          ' style="width:16px;height:16px;" ' + 'src="http'
        );
        html = html.replace(
          /src="images/g,
          'src="' + this.$store.state.baseUrl + 'images'
        );
        this.html = html.replace(
          /src="\/utf8/g,
          'src="' + this.$store.state.baseUrl + 'utf8'
        );
        this.banner = this.$store.state.baseUrl + this.article.basicThumbnails
      });
    });
  },
  methods: {
    ...mapActions(["findAll", "getArticle", "findPage"]),
    chooseCategory(id) {
      this.$store.commit('setCategory', {id: id})
      this.$router.push({path:'/layout/main/'+id})
    }
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
}
.logos {
  width: 80%;
  display: flex;
  flex-wrap: wrap;
  margin: 30px auto;
  cursor: pointer;
  .logo {
    width: 20%;
    padding: 30px;
    img {
      width: 100%;
    }
  }
}
.intro {
  width: 80%;
  margin: 30px auto;
}
</style>


